import { isEmpty } from 'lodash';
import React, { useEffect, useState } from 'react';

/* eslint-disable-next-line import/prefer-default-export */
export const getReportTabUrl = (isDefault, url, resource) => {
  if (isDefault) {
    return `${url}`;
  }
  if (url !== '/') {
    return `${url}/${resource}`;
  }
  return `${url}reports/${resource}`;
};

export const getDashboardTabUrl = (isDefault, url, resource) => {
  if (isDefault) {
    return `${url}`;
  }
  if (url !== '/') {
    return `${url}/${resource}`;
  }
  return `${url}dashboard/${resource}`;
};

export const getChargebeeSubscriptionIdParam = (search) => {
  const params = new URLSearchParams(search);
  return params.get('subscription_id');
};

export const useManagedServiceSignupGuard = (
  location,
  subscription,
  history,
  getChargebeeSubscription,
  dispatchError,
) => {
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    (async () => {
      const subscriptionId = getChargebeeSubscriptionIdParam(location.search);
      if (subscriptionId) {
        await getChargebeeSubscription({ subscription_id: subscriptionId });
      }
    })();
  }, [location.pathname]);

  useEffect(() => {
    if (location.pathname !== '/signup/managed-service') {
      return setChecking(false);
    }
    const subscriptionId = getChargebeeSubscriptionIdParam(location.search);
    if (!subscriptionId) {
      setChecking(false);
      dispatchError({ message: 'Please provide a subscription id' });
    }
    if (!subscription.loaded) {
      return setChecking(true);
    }
    if (isEmpty(subscription.chargebee_data) || subscription.error) {
      dispatchError({
        // eslint-disable-next-line no-multi-str
        message: (
          <span>
            Oops looks like this page has expired,<br />
            but good news your account was created,<br />
            just go <a href="/forgot">here</a> to reset your password.
          </span>),
      });
      setChecking(false);
    }
    return null;
  }, [subscription.loaded, location.pathname]);

  return checking;
};
